// Which AUT lane columns a table shows.
//
// The EKS/RDS lanes ('*_v2') are deprecated and the v1 lanes ('aut_psql' / 'aut_mysql') are
// gone entirely — nothing starts either any more. Records made before the switch still carry
// their results, so a retired lane keeps its column for as long as something on screen has
// results to put in it, then disappears on its own.
export function visibleLanes(allLanes, records = []) {
  return allLanes.filter(
    ({ key, retired }) => !retired || records.some((record) => record?.[key] !== undefined)
  );
}

// The lanes a release's testing runs can carry, in column order.
export const RELEASE_AUT_LANES = [
  { key: 'aut_psql',       label: 'Postgres',        retired: true },
  { key: 'aut_mysql',      label: 'MySQL',           retired: true },
  { key: 'aut_psql_v2',    label: 'Postgres V2',     retired: true },
  { key: 'aut_mysql_v2',   label: 'MySQL V2',        retired: true },
  { key: 'aut_psql_kind',  label: 'Postgres (kind)' },
  { key: 'aut_mysql_kind', label: 'MySQL (kind)'    },
];
